import { render } from "./CurrencyExchange.vue?vue&type=template&id=744737e3&scoped=true"
import script from "./CurrencyExchange.vue?vue&type=script&lang=js"
export * from "./CurrencyExchange.vue?vue&type=script&lang=js"

import "./CurrencyExchange.vue?vue&type=style&index=0&id=744737e3&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-744737e3"]])

export default __exports__